import { Theme } from '@mui/material';
import { ComponentsOverrides } from '@mui/material/styles/overrides';

// TODO: Remove style duplicates in other places
export const MUI_BUTTON_OVERRIDES: ComponentsOverrides<Theme>['MuiButton'] = {
  // Base | primary
  root: ({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    fontSize: theme.spacing(1.75),
    textTransform: 'capitalize',
  }),

  // Outlined
  outlined: ({ theme }) => ({
    color: theme.palette.common.white,
    borderColor: '#3d3f5e',
    borderRadius: theme.spacing(1),
    textTransform: 'capitalize',
    fontWeight: 'bold',

    '&:hover': {
      borderColor: theme.palette.common.white,
    },
  }),

  outlinedError: ({ theme }) => ({
    color: theme.palette.text.primary,
    border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,

    '&:hover': {
      border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,
      backgroundColor: theme.palette.error.light,
    },
  }),
};
